








































import {Vue, Component, Prop} from 'vue-property-decorator';
import {ServiceRecordDTO} from "@/components/payroll/business/services/ServiceDTO";
import moment from "moment/moment";

export type ServiceLogViewSide = "CONTRACTOR" | "EMPLOYER"
type Mode = "SHORT" | "FULL";

@Component({
	computed: {
		moment() {
			return moment
		}
	}
})
export default class ServiceLogView extends Vue {

	@Prop()
	private log!: ServiceRecordDTO

	@Prop()
	private side!: ServiceLogViewSide

	@Prop({default: true})
	private disablable!: boolean

	@Prop({default: true})
	private mutable!: boolean

	mounted() {
		console.log(this.log.quantity)
	}

	private mode: Mode = "SHORT"

	private toEdit() {
		console.log(this.$emit("edit", this.log))
	}

	private disable() {
		this.$emit("disable", this.log)
	}
}
